import {Injectable} from '@angular/core';
import {RestHttpService} from '@catcore/services/rest-http.service';
import {StatusInfo} from '@catfeatures/types';
import {FeatureOptionTokenCreateInfo} from '@catmodules/models/feature-option-tokens/types';
import {Restangular} from 'ngx-restangular';
import {Observable} from 'rxjs/Observable';
import {Project} from "@catcore/types/api-v2";
import {BehaviorSubject} from "rxjs";

/**
 * Service to manage all aspects around one or many FeatureUnit models
 */
@Injectable()
export class FeatureOptionTokenService extends RestHttpService<StatusInfo> {

  listSubject = new BehaviorSubject([]);

  constructor(service: Restangular) {
    super('feature-option-tokens', service);
  }

  /**
   * Initiates the process to create a single FeatureOptionToken through the WebAPI
   * @param {FeatureOptionTokenCreateInfo} item
   * @returns {Observable<any>}
   */
  create(item: FeatureOptionTokenCreateInfo): Observable<any> {
    return this.add({
        value: item.value,
        description: item.description,
        feature: item.featureType,
      })
      .map((createdFeature) => {
        return createdFeature;
      });
  }

  getOptionTokens(): Observable<any[]> {
    return this
      .getAll()
      .map((tokens: any[]) => {
        this.listSubject.next(tokens);
        return tokens;
      });
  }

}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_release@2/app/Resources/Public/src/app/modules/models/feature-option-tokens/services/feature-option-token.service.ts